let initialState = {
	userChannels: false
};
const ChannelsData = (state = initialState, action) => {
	
	switch (action.type) {
		case "SET_SOCIAL_CHANNEL_STATUS":
			return {
				...state,
				userChannels: action.payload,
			};
		default:
			return state;
	}
};

export default ChannelsData;
